import * as api from '../api'
import request from '../request'


const getConfigData = data => {
  return request({
    url : api.getConfigData,
    method : 'POST',
    data
  })
}

const addConfig = data => {
  return request({
    url : api.addConfig,
    method : 'POST',
    data
  })
}

const systemM = data => {
	return request({
	  url : api.execute,
	  method : 'POST',
	  data
	})
}

// 获取短信系统配置
const getConfigMessageInfo = () => {
  return request({
    url : api.getConfigMessage,
    method : "POST",
  })
}

// 修改短信系统配置setConfigMessage
const setConfigMessageInfo = (data) => {
  return request({
    url : api.setConfigMessage,
    method : "POST",
    data
  })
}

// 自定义信息
const getExtDefConfigListFn = (data) => {
  return request({
    url: api.getExtDefConfigList,
    data
  })
}
const deleteExtDefConfigFn = (data) => {
  return request({
    url: api.deleteExtDefConfig,
    data
  })
}
const saveExtDefConfigListFn = (data) => {
  return request({
    url: api.saveExtDefConfigList,
    data
  })
}
const selectExtDefConfigFn = (data) => {
  return request({
    url: api.selectExtDefConfig,
    data
  })
}
const exportUserArrangement = () => {
  return request({
    url: api.exportUserArrangement,
    method: 'POST',
  })
}
export default {
    getConfigData,
    addConfig,
	  systemM,
    getConfigMessageInfo,
    setConfigMessageInfo,
    getExtDefConfigListFn,
    deleteExtDefConfigFn,
    saveExtDefConfigListFn,
    selectExtDefConfigFn,
    exportUserArrangement
} 